import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
// --- external imports -----

import Asset from './BaseAssets';
// --- local imports -----

const FONT_SIZE = 10;

const pxToEm = (px, fontSize = FONT_SIZE) => {
    return px / fontSize;
};

const disabled = ({ disabled }) => css`
    filter: ${disabled ? 'brightness(0.5)' : 'none'};
`;

const backgroundSize = ({ backgroundSizeInEm }) => css`
    background-size: ${backgroundSizeInEm.width}em ${backgroundSizeInEm.height}em;
`;

const animation = ({ animationConfig, backgroundPositionXAt100InEm }) => css`
    animation: ${keyFrames(backgroundPositionXAt100InEm)} ${animationConfig.timeInSecs}s steps(${animationConfig.steps})
        ${animationConfig.delayInSecs}s ${animationConfig.repetition} forwards;
`;

const keyFrames = backgroundPositionXAt100InEm =>
    keyframes`
		100% {
			background-position-x: ${backgroundPositionXAt100InEm}em;
			background-position-y: 0;
		}
	`;

const AnimatedImageSpriteTag = styled(Asset.Img)`
    background-position: 0px 0px;
    ${backgroundSize};
    ${animation};
    ${disabled};
`;

// just wrapper to calculate sizes in em
const AnimatedImageSprite = props => {
    const { frame, animation, fontSize } = props;
    return (
        <AnimatedImageSpriteTag
            {...props}
            animationConfig={animation}
            backgroundSizeInEm={{
                width: pxToEm((animation.steps + 1) * frame.width, fontSize),
                height: pxToEm(frame.height, fontSize),
            }}
            // using -1 as motion is forwards
            backgroundPositionXAt100InEm={pxToEm(animation.steps * frame.width, fontSize) * -1}
            projection={{
                src: props.spriteSrc,
                width: frame.width,
                height: frame.height,
            }}
        />
    );
};

export default AnimatedImageSprite;
